import { useTranslation } from "react-i18next";
import LanguageSelect from "./LanguageSelect";

// The practice-language selector is hidden on views it doesn't apply to
// (e.g. the teaching view), where stats aren't scoped to one language.
const Greeting = ({ selectedLanguage, setSelectedLanguage, showLanguageSelect = true }) => {
    const { t } = useTranslation();
    let timePeriod = "";
    let timePeriodGender = "";
    const hour24 = new Date().getHours();
    let periodKey = "";
    if (hour24 >= 4 && hour24 < 12) {
        periodKey = "morning";
    } else if (hour24 >= 12 && hour24 < 14) {
        periodKey = "afternoon1";
    } else if (hour24 >= 14 && hour24 < 17) {
        periodKey = "afternoon2";
    } else if (hour24 >= 17 && hour24 < 21) {
        periodKey = "evening";
    } else {
        periodKey = "night";
    }
    timePeriod = t(`timesOfDay.${periodKey}.label`);
    timePeriodGender = t(`timesOfDay.${periodKey}.gender`);

    const randomNumber1to5 = Math.floor(Math.random() * 5) + 1;
    const greeting =
        t("greetingPrecedingAdjective") +
        " " +
        t(`indefiniteArticle.${timePeriodGender}`) +
        " " +
        t(`greetingAdjective.${randomNumber1to5}.${timePeriodGender}`).toLowerCase() +
        " " +
        timePeriod +
        " 😊";

    return (
        <div className="flex items-center justify-between">
            <h1 className="pr-4 text-large hidden sm:block sm:text-xl lg:text-3xl">{greeting}</h1>

            {showLanguageSelect && (
                <div>
                    <LanguageSelect
                        selectedLanguage={selectedLanguage}
                        setSelectedLanguage={setSelectedLanguage}
                    />
                </div>
            )}
        </div>
    );
};

export default Greeting;
